import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault, renderIf} from 'views/Shared'
import {ItemInformation} from 'components/common/ItemInformation'
import copyToClipboard from "copy-to-clipboard";
import {message} from "antd";
import {IoCopyOutline} from "react-icons/io5";

export const renderCourseSubject = ({ detail = true, renderActions = NullAsDefault, handleAction = (() => {})} = {}) => (item, index) => {
    const {subject, is_linked, number_of_credits, number_of_sessions, is_mandatory} = item ?? {}
    const {description, subject_idcode} = subject ?? {}

    return (
        <Translate key={index}>
            {(t) => (
                <div style={{ fontSize: 14 }} className="p-4 flex flex-col custom-item-render relative list-item">
                    <div className="flex items-center gap-3">
                        <div className="flex flex-col flex-1">
                            <div className="font-bold text-base text-gray-800 tracking-wide">
                                {getTitle(subject)}
                            </div>
                            <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-1">
                                <ItemInformation
                                    showIcon={false}
                                    label="subject code"
                                    value={
                                        <span
                                            onClick={() => {
                                                copyToClipboard(subject_idcode)
                                                message.success(t('copied'))
                                            }}
                                            className="font-mono font-semibold text-secondary hover:text-secondary-600 cursor-pointer">
                                            {subject_idcode}
                                            <IoCopyOutline size={12} className="ml-1"/>
                                        </span>
                                    }
                                    className="tracking-wider"
                                />
                                {renderIf(
                                    is_mandatory === 1,
                                    <span className="text-primary-400 italic tracking-wider">
                                        {`* ${t('is mandatory subject')}`}
                                    </span>
                                )}
                            </div>
                        </div>
                        {renderActions(item)}
                    </div>
                    <div className="my-2 border-b border-color-50"/>
                    {renderIf(
                        is_linked,
                        <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-1">
                            <ItemInformation
                                showIcon={true} label="number of sessions" className="italic tracking-wider"
                                value={`${number_of_sessions} ${t('sessions')}`}
                            />
                            <ItemInformation
                                showIcon={true} label="number of credits" className="text-xs tracking-wider"
                                value={`${number_of_credits} ${t('credits')}`}
                            />
                        </div>
                    )}
                    {renderIf(
                        description,
                        <div className="mt-3 text-color-300 tracking-wider max-lines-3">{description}</div>
                    )}
                </div>
            )}
        </Translate>
    )
}
